export const hcExtra = {
  reservas: {
    buscar: "Search",
    limpiar: "Clear",
    todas: "All",
  },
  nav: {
    volver: "Back",
  },
  listingDetail: {
    badgeNew: "New",
  },
  ofertas: {
    precio: "Price",
  },
  payService: {
    sendRequest: "Send request",
  },
  accountCfg: {
    accountEmail: "Account email",
  },
};
